<template>
    <div class="photo-lower-bar-button-group">
        <div class="photo-lower-bar-button">
            <div class="photo-lower-bar-button-text" @click="undo(undoLen)" v-bind:class="{'disabled-btn': undoLen === 0 || undoCounter > 10 || undoLen-redoLen === 1}">Отменить</div>
        </div>
        <div class="photo-lower-bar-button">
            <div class="photo-lower-bar-button-text" @click="redo(redoLen)" v-bind:class="{'disabled-btn': redoLen === 0}">Повторить</div>
        </div>
        <div class="photo-lower-bar-button-custom" @click="rotate(-90)">
            <SVGPhotoRotateLeftE class="lb-svg-rotate"/>
        </div>
        <div class="photo-lower-bar-button-custom no-left-padding" @click="rotate(90)">
            <SVGPhotoRotateRightE class="lb-svg-rotate"/>
        </div>
        <div class="photo-lower-bar-button no-left-padding collapsable">
            <div class="photo-lower-bar-button-text" style="cursor: default; color: #939393;">Повернуть</div>
        </div>
        <div class="photo-lower-bar-button" @click="crop">
            <SVGPhotoCut class="lb-svg"/>
            <span class="photo-lower-bar-button-text extra-left-padding collapsable">Кадрировать</span>
        </div>
        <div class="photo-lower-bar-button" v-on:click="showModal('photo-delete-modal')">
            <SVGPhotoDelete class="lb-svg"/>
            <span class="photo-lower-bar-button-text extra-left-padding collapsable" v-on:click="showModal('photo-delete-modal')">Удалить</span>
        </div>
    </div>
</template>

<script>
    import {modalMethods} from "../../common.js";
    import {bus} from "../../../vue_bus";
    import SVGPhotoRotateLeft from "../../SVG/SVGPhotoRotateLeft";
    import SVGPhotoRotateRight from "../../SVG/SVGPhotoRotateRight";
    import SVGPhotoCut from "../../SVG/SVGPhotoCut";
    import SVGPhotoDelete from "../../SVG/SVGPhotoDelete";
    import SVGPhotoRotateRightE from "../../SVG/SVGPhotoRotateRightE";
    import SVGPhotoRotateLeftE from "../../SVG/SVGPhotoRotateLeftE";

    export default {
        name: "LeftLowerBarPhoto",
        components: {
            SVGPhotoRotateLeftE,
            SVGPhotoRotateRightE,
            SVGPhotoDelete,
            SVGPhotoCut,
            SVGPhotoRotateRight,
            SVGPhotoRotateLeft
        },
        mixins: [modalMethods],
        data() {
            return {
                undoCounter: 0,
            }
        },
        computed: {
            undoLen() {
                return this.$store.state.photoEditorData.undoStackLength
            },
            redoLen() {
                return this.$store.state.photoEditorData.redoStackLength
            }
        },
        methods: {
            crop() {
                this.$router.push({name: "CropPhoto"}).catch(() => {});
            },
            undo(len) {
                if (len !== 0 && this.undoCounter <= 10 && this.undoLen-this.redoLen !== 1) {
                    bus.$emit("phe_click_undo");
                    this.undoCounter += 1
                }
            },
            redo(len) {
                if (len !== 0) {
                    bus.$emit("phe_click_redo");
                    this.undoCounter -= 1
                }
            },
            rotate: (angle) => {
                bus.$emit("phe_click_rotate", angle);
            }
        }
    }
</script>

<style scoped>
    @media (max-width: 1550px) {
        .collapsable {
            display: none !important;
        }
    }

    .disabled-btn {
        color: #cccccc !important;
        cursor: no-drop;
    }

    .btn-rotate {
        position: relative;
    }

    .photo-lower-bar-button-custom {
        display: inline-block;
        color: #939393;
        cursor: pointer;
        user-select: none;
    }

    .photo-lower-bar-button-custom:hover {
        color: #808080;
    }

    .photo-lower-bar-button-custom:active {
        color: #707070;
    }
</style>
